module.exports = __webpack_public_path__ + "img/home_stretches_video.7bb80dc6.png";